import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  TextField,
  makeStyles
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import MaterialTable from "material-table";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
  CommonUrl,
  iconBucketUrl,
  NONCE,
  TIME_STAMP,
  myHeaderStyle,
  mySearchFieldStyle,
  logoutMsg
} from "../common-url/CommonUrl";
import { useHistory } from "react-router";
import { toast } from "react-toastify";


const useStyles = makeStyles(theme => ({
  root: {
    /*"& .MuiPaper-root": {
      borderBottom: "none",
      backgroundColor:"transparent",
      boxShadow:"none"
    },*/
    "& .MuiInput-underline:before":{
      borderBottom: 0,
    },
    "& .MuiInput-underline:after":{
      borderBottom: 0,
    },
    "& .MuiInput-root":{
      borderBottom: 0,
    },
    "&:last-child td": {
      // borderBottom: 0,
    },
  },
}));


export default function Icons() {
  const [icon, setIcon] = useState([]);
  // const [setSelectedRow] = useState(null);
  const [snackMsg, setSnackMsg] = useState();
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const classes = useStyles();

  const [nameError, setNameError] = useState({
    error: false,
    label: "",
    helperText: "",
    validateInput: false
  });

  const columns = [
    { title: "Sr No", render: rowData => rowData.tableData.id + 1 },

    {
      title: "Image",
      field: "vIconFile",
      editable: false,
      filtering: false,
      render: rowData => (
        <div>
          {rowData.vIconFile == null ? (
            <Avatar className="p-2">{rowData.vIconName}</Avatar>
          ) : (
            <Avatar
              className="border solid p-2 "
              src={iconBucketUrl + rowData.vIconFile}
            />
          )}
        </div>
      )

      // render: rowData => <img src={(baseUrl + "/" + rowData.vFilePath)} style={{ width: 70 }} alt="Upload" />
    },
    // http://localhost:6001/public/roomTypeImages/2021-05-09T13:21:28.338ZScreenshot%20from%202021-03-24%2012-34-46.png
    {
      title: "Name",
      field: "vIconName",
      filterPlaceholder: "Icon Name",
      // validate: rowData => (rowData.vIconName ? true : 'Name can not be empty')
      // validate: rowData => rowData.vIconName === '' ? 'Name cannot be empty' : ''
      editComponent: props => (
        <TextField
          type="text"
          error={
            !props.value && nameError.validateInput && props.rowData.submitted
              ? nameError.error
              : false
          }
          helperText={
            !props.value && nameError.validateInput && props.rowData.submitted
              ? nameError.helperText
              : ""
          }
          value={props.value ? props.value : ""}
          onChange={e => {
            if (nameError.validateInput) {
              setNameError({
                ...nameError,
                validateInput: false
              });
            }

            props.onChange(e.target.value);
          }}
        />
      )
    }
  ];
  // ----------------------------------------------------------------
  //--------------get the all Icon list at initial loading
  // ----------------------------------------------------------------
  useEffect(() => {
    fetchIcons();
  }, []);
  // var encToken = sessionStorage.getItem("encToken");
  const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
  const history = useHistory();

  const fetchIcons = async () => {
    await fetch(CommonUrl.iconBaseUrl + "/get-all-icons", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code == 401) {
					history.push("/logout");
          toast.info(logoutMsg,{autoClose:5000})
				} else {
        setIcon(response.data);
      }
      });
  };
  // ----------------------------------------------------------------
  // adding a Icon
  // ----------------------------------------------------------------
  const handleRowAdd = newIcon => {
    fetch(CommonUrl.iconBaseUrl + "/add-icon", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      },
      body: JSON.stringify({
        vIconName: newIcon.vIconName
      })
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          fetchIcons();
          setSnackMsg(response.message);
          handleClickSuccess();
        } else {
          setSnackMsg(response.message);
          handleClickError();
        }
      });
  };

  // ----------------------------------------------------------------
  // delete a Icon
  // ----------------------------------------------------------------
  const handleRowDelete = (iconDeleteId, oldFileName) => {
    fetch(CommonUrl.iconBaseUrl + "/delete-icon", {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      },
      body: JSON.stringify({
        iIconId: iconDeleteId,
        oldFileName: oldFileName
      })
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          fetchIcons();
          setSnackMsg(response.message);
          handleClickSuccess();
        } else {
          setSnackMsg(response.message);
          handleClickError();
        }
      });
  };

  // ----------------------------------------------------------------
  //                         update a Icon
  // ----------------------------------------------------------------
  const handleRowUpdate = updatedRow => {
    // console.log(updatedRow)
    fetch(CommonUrl.iconBaseUrl + "/update-icon", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      },
      body: JSON.stringify({
        iIconId: updatedRow._id,
        vIconName: updatedRow.vIconName
      })
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          fetchIcons();
          setSnackMsg(response.message);
          handleClickSuccess();
        } else {
          setSnackMsg(response.message);
          handleClickError();
        }
      });
  };

  // ----------------------------------------------------------------
  //---------------------snackbar operations starts-----------------
  // ----------------------------------------------------------------

  const handleClickSuccess = () => {
    setOpenSuccess(true);
  };
  const handleClickError = () => {
    setOpenError(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
    setOpenError(false);
    setOpenImage(false);
  };
  // snackbar operations end

  // ------------------------------------------------------
  // --------------------Image Upload----------------------
  // ------------------------------------------------------

  const [selectedImage, setSelectedImage] = useState();
  const [openImage, setOpenImage] = useState(false);
  const [selectRowData, setSelectRowData] = useState({});

  const handleImage = (event, rowDetails) => {
    setSelectRowData(rowDetails);
    setOpenImage(true);
  };
  const handleSelectImage = event => {
    setSelectedImage(event.target.files[0]);
  };

  const handleUploadImage = (event, image) => {
    const data = new FormData();
    data.append("vFileDetails", selectedImage);
    data.append("iconID", selectRowData._id);
    data.append("oldFileName", selectRowData.vIconFile);

    fetch(CommonUrl.iconBaseUrl + "/upload-image", {
      method: "post",
      body: data,
      headers: {
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code === 200) {
          setOpenImage(false);
          fetchIcons();
          setSnackMsg(response.message);
          handleClickSuccess();
        } else {
          setSnackMsg(response.message);
          handleClickError();
        }
      });
  };

  return (
    <div className="App">
      <div>
        <Dialog
          open={openImage}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Upload Image for{" "}
            <span className="text-primary">{selectRowData.vIconName}</span>
          </DialogTitle>
          <DialogContent>
            <input
              id="outlined-basic"
              className="form-control"
              type="file"
              onChange={handleSelectImage}
              required
            ></input>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleUploadImage} color="primary">
              Upload
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* snackbar starts */}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={openError}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          {snackMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={openSuccess}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          {snackMsg}
        </Alert>
      </Snackbar>
      {/* snackbar ends */}

      {/* material table starts */}
<div className={classes.root}>
      <MaterialTable
        title="Icons List"
        style={{ paddingInline: "30px", paddingTop: "10px" }}
        data={icon}
        columns={columns}
        /* detailPanel={rowData => {
					if (rowData.vIconFile == null) {
						return <div style={{
							fontSize: 70,
							textAlign: 'center',
							color: 'white',
							background: "linear-gradient(to top, #3699FF, #1BC5BD)",
						}}>No Image Uploaded</div>

					}
					return (
						<iframe
							title={rowData._id}
							width="100%"
							height="150"
							src={(iconBucketUrl + rowData.vIconFile)}
							frameborder="3"
						/>
					)
				}} */
        /* 	actions={[
						{
							icon: 'upload',
							tooltip: 'Upload Image',
							disabled: true,
							type: 'file',
							onClick: (event, rowDetails) => {
								// Do save operation
								handleImage(event, rowDetails);
							}
						}
					]} */
        /* 		editable={{
							isDeletable: rowData => false,
							isEditable: rowData => false,
							onRowAdd: (newIcon) =>
								new Promise((resolve, reject) => {
									setTimeout(() => {
										newIcon.submitted = true;
										if (!newIcon.vIconName) {
											setNameError({
												error: true,
												label: "required",
												helperText: "Name is required.",
												validateInput: true,
											});
											reject();
											return;
										}
										handleRowAdd(newIcon)
										resolve();
									}, 600);
								}),
							onRowDelete: selectedRow => new Promise((resolve, reject) => {
								const iconDeleteId = (selectedRow._id)
								const oldFileName = (selectedRow.vIconFile)
								setTimeout(() => {
									handleRowDelete(iconDeleteId, oldFileName)
									resolve()
								}, 1000)
							}),
							onRowUpdate: (updatedRow, oldRow) => new Promise((resolve, reject) => {
								setTimeout(() => {
									handleRowUpdate(updatedRow)
									resolve()
								}, 1000)
							})
						}} */
        // onRowClick={(evt, selectedRow, togglePanel) => togglePanel()}
        options={{
          // filtering: true,
          actionsColumnIndex: -1,
          addRowPosition: "first",
          headerStyle: myHeaderStyle,
          searchFieldStyle:mySearchFieldStyle,
          emptyRowsWhenPaging: false, // To avoid of having empty rows
        }}
      />
      </div>
      {/* material table ends */}
    </div>
  );
}
